package one.healthium.log_weight.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import one.healthium.log_weight.ui.internal.LogWeightControl
import one.healthium.log_weight.ui.internal.LogWeightEvents
import one.healthium.log_weight.ui.internal.LogWeightViewModel
import one.healthium.rateus.data.ShowAppRateForWeightLoss
import one.healthium.ui.common.event_producer.EventEffect
import one.healthium.ui.common.message.AlertUiMessageHandler
import one.healthium.ui.compose.components.AppSheetTopBar
import org.koin.compose.viewmodel.koinViewModel

interface LogWeightEventDelegate {
    fun onCloseClicked()
}

@Composable
fun LogWeightScreen(
    taskId: String?,
    eventDelegate: LogWeightEventDelegate,
) {
    val viewModel = koinViewModel<LogWeightViewModel>()
    val state by viewModel.state.collectAsState()
    var rateApp by remember { mutableStateOf<LogWeightEvents.OnWeightAdded?>(null) }

    EventEffect(viewModel.events) { event ->
        when (event) {
            is LogWeightEvents.OnWeightAdded -> {
                if (event.delta != 0f) {
                    rateApp = event
                } else {
                    eventDelegate.onCloseClicked()
                }
            }
        }
    }

    Column(Modifier.testTag("log_weight_screen")) {
        AppSheetTopBar(
            onCloseClicked = eventDelegate::onCloseClicked,
        )
        val latestWeightLog = state.latestWeightLog
        if (latestWeightLog != null) {
            LogWeightControl(
                uiModel = latestWeightLog,
                isMetric = state.isMetric,
                saveInProgress = state.loading,
                onSaveClicked = { newValue ->
                    viewModel.onUpdateWeight(newValue, taskId)
                }
            )
        }
    }

    rateApp?.let {
        ShowAppRateForWeightLoss(
            delta = it.delta,
            onDismissRequest = { eventDelegate.onCloseClicked() }
        )
    }

    AlertUiMessageHandler(viewModel.uiMessage)
}